import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import type { User } from "@/contexts/AuthContext";

type Props = {
  children: React.ReactNode;
};

export default function AdvertiserRoute({ children }: Props) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-32 text-center text-ink-500">
        Carregando...
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }
  if ((user as User).role === "admin") {
    return <Navigate to="/admin" replace />;
  }
  return children;
}